import { Stack } from "@mui/joy";
import React from "react";
import { SelectButtonCircleV2 } from "components/common/SelectButtonCircleV2";
import { SelfCheckQuestion } from "components/common/SelfCheckQuestion";
import { useRecoilState } from "recoil";
import { refundQnAListState } from "../../recoil/refundQnAtom";
import { useNavigate } from "react-router-dom";

export interface QnaAnswerOption {
  id: number;
  text: string;
}

// 옵션 리스트
const options: QnaAnswerOption[] = [
  { id: 1, text: "매우 동의" },
  { id: 2, text: "동의" },
  { id: 3, text: "동의" },
  { id: 4, text: "매우 동의" },
];

export default function Refund_QnA({
  pageSeq,
  questionId,
  mainQuestion,
  leftQuestion,
  rightQuestion,
}: {
  pageSeq: number;
  questionId: number;
  mainQuestion: string;
  leftQuestion: string;
  rightQuestion: string;
}) {
  const [refundQnAList, setRefundQnAList] = useRecoilState(refundQnAListState);
  const navigate = useNavigate();
  // const { currentQuestion, qaList, handleSelectAnswer } = useQnAOnboarding({
  //   pageKey: pageKey,
  //   questionList: questionList,
  //   basePath: "/onboarding_new/convention/2",
  //   nextPageRoute: "/onboarding_new/convention/3",
  // });

  const handleSelectAnswer = (
    questionId: number,
    answerId: number,
    answer: string
  ) => {
    // 선택한 답변을 refundQnAState에 저장
    setRefundQnAList((prev) => {
      const idx = prev.findIndex((qa) => qa.questionId === questionId);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { questionId, answerId, answer };
        return next;
      }
      return [...prev, { questionId, answerId, answer }];
    });

    setTimeout(() => {
      navigate(`/refund?seq=${pageSeq + 1}`);
    }, 400);
  };

  return (
    <Stack
      sx={{
        width: "100%",
        height: "85%",
        py: "20px",
        px: "24px",
        mx: "auto",
      }}
      justifyContent="center"
    >
      <Stack
        sx={{ flex: 1 }}
        justifyContent="center"
        alignItems={"center"}
        spacing={"24px"}
      >
        <SelfCheckQuestion
          question={{
            main: mainQuestion,
            left: leftQuestion,
            right: rightQuestion,
          }}
        />
        <Stack
          direction="row"
          sx={{ width: "100%" }}
          justifyContent={"space-between"}
        >
          {options.map((option, optionIndex) => (
            <SelectButtonCircleV2
              key={`${questionId}-${option.id}`}
              questionId={questionId}
              selected={
                refundQnAList.find((qa) => qa.questionId === questionId)
                  ?.answerId === option.id
              }
              disable={false}
              option={option}
              handleClick={() =>
                handleSelectAnswer(questionId, option.id, option.text)
              }
            />
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}
